module.exports = __webpack_public_path__ + "img/12.f9d48ada.png";